module.exports = __webpack_public_path__ + "img/eu.def3cba2.svg";